import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { useResponsiveValue } from '@wp-g2/styles';
import React from 'react';
import { VStack } from '../VStack';
import { ListGroupContext } from './ListGroup.Context';

function ListGroups(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ListGroups'),
      _useContextSystem$ins = _useContextSystem.inset,
      inset = _useContextSystem$ins === void 0 ? false : _useContextSystem$ins,
      _useContextSystem$spa = _useContextSystem.spacing,
      spacing = _useContextSystem$spa === void 0 ? 6 : _useContextSystem$spa,
      otherProps = _objectWithoutProperties(_useContextSystem, ["inset", "spacing"]);

  var insetValue = useResponsiveValue(inset);
  var contextValue = React.useMemo(function () {
    return {
      inset: insetValue
    };
  }, [insetValue]);
  return /*#__PURE__*/React.createElement(ListGroupContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(VStack, Object.assign({
    spacing: spacing
  }, otherProps, {
    ref: forwardedRef
  })));
}

export default contextConnect(ListGroups, 'ListGroups');